import { HStack, PinInput, Button } from "@chakra-ui/react";
import { useState, useRef, forwardRef, useImperativeHandle } from "react";

const CustomPINInput = forwardRef(({ verify, isBusy, setIsBusy, reset, onFocus, onPointerDownCapture }, ref) => {
  const [verified, setVerified] = useState(true);
  const [validationTriggered, setValidationTriggered] = useState(false);

  const [pin, setPin] = useState(new Array(6).fill(""));
  const hiddenInputRef = useRef(null);
  const firstRef = useRef(null);

  useImperativeHandle(ref, () => ({
    blur: () => {
      hiddenInputRef.current?.blur();
      firstRef.current?.blur();
    }
  }));

  const clear = () => {
    setPin(new Array(6).fill(""));
    setVerified(false);
    setValidationTriggered(false);
    reset();
    firstRef.current?.focus(); // optional: focus first box again
  };

  return (
    <HStack justify="center" spacing={["2px", "20px"]}>
      <PinInput.Root
        size="xl"
        required
        otp
        value={pin}
        onValueChange={(e) => {
          setPin(e.value);
          // Trigger validation only once when user first starts entering PIN
          if (e.value.some(val => val !== "") && onFocus && !validationTriggered) {
            setValidationTriggered(true);
            onFocus();
          }
        }}
        invalid={!verified}
        disabled={isBusy}
        onValueComplete={async (e) => {
          const value = e.value.join("");
          if (isBusy) return;
          setIsBusy(true);
          try {
            const res = await verify(value);
            if (res) {
              setVerified(true);
            } else {
              setVerified(false);
            }
          } catch (err) {
            setVerified(false);
          } finally {
            setIsBusy(false);
          }
        }}
        onPointerDownCapture={onPointerDownCapture}
      >
        <PinInput.HiddenInput ref={hiddenInputRef} />

        <PinInput.Control>
          {[...Array(6)].map((_, idx) => {
            /* const pinProps = {
              sx: pinInputStyles,
              height: "50px",
              width: ["47px", "50px"],
              fontSize: ["24px", "30px"],
              _placeholder: { color: "#cdcdcd" },
            }; */

            if (idx === 0) {
              return (
                <PinInput.Input
                  ref={firstRef}
                  key={`pin_input_${idx}`}
                  index={idx}
                  onFocus={() => {
                    if (onFocus && !validationTriggered) {
                      setValidationTriggered(true);
                      onFocus();
                    }
                  }}
                  //{...pinProps}
                />
              );
            } else {
              return (
                <PinInput.Input
                  key={`pin_input_${idx}`}
                  index={idx}
                  onFocus={() => {
                    if (onFocus && !validationTriggered) {
                      setValidationTriggered(true);
                      onFocus();
                    }
                  }}
                  //  {...pinProps}
                />
              );
            }
          })}
        </PinInput.Control>
      </PinInput.Root>
      <Button onClick={clear} variant="ghost" size="sm">
        Clear
      </Button>
    </HStack>
  );
});

CustomPINInput.displayName = "CustomPINInput";

export default CustomPINInput;
